import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import { zhCN } from 'date-fns/locale';
import clsx from 'clsx';

const ActivityFeed = ({ activity }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'inspection':
        return 'fa-check-square-o';
      case 'training':
        return 'fa-graduation-cap';
      case 'certificate':
        return 'fa-id-card-o';
      case 'system':
        return 'fa-cog';
      default:
        return 'fa-bell';
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case 'inspection':
        return 'bg-blue-500';
      case 'training':
        return 'bg-green-500';
      case 'certificate':
        return 'bg-red-500';
      case 'system':
        return 'bg-yellow-500';
      default:
        return 'bg-gray-500';
    }
  };

  const getActionText = (action) => {
    const actionMap = {
      'create': '创建了',
      'update': '更新了',
      'delete': '删除了',
      'complete': '完成了',
      'approve': '批准了',
      'reject': '拒绝了',
      'expiring': '即将过期',
      'expired': '已过期',
      'create_finding': '发现了',
      'resolve': '解决了',
      'assign': '分配了',
    };
    return actionMap[action] || action;
  };

  const formatTime = (timestamp) => {
    try {
      return formatDistanceToNow(new Date(timestamp), {
        addSuffix: true,
        locale: zhCN,
      });
    } catch (error) {
      return '时间未知';
    }
  };

  return (
    <div className="px-6 py-4 flex items-center">
      <div className="flex-shrink-0">
        <div className={clsx('h-10 w-10 rounded-full flex items-center justify-center', getActivityColor(activity.type))}>
          <i className={`fa ${getActivityIcon(activity.type)} text-white`}></i>
        </div>
      </div>
      <div className="ml-4 flex-1">
        <p className="text-sm text-gray-900">
          <span className="font-medium">{activity.user?.full_name || '系统'}</span>
          {' '}
          <span className="text-gray-600">{getActionText(activity.action)}</span>
          {' '}
          <span className="font-medium">{activity.description || '某项操作'}</span>
        </p>
        <p className="text-xs text-gray-500 mt-1">{formatTime(activity.created_at)}</p>
      </div>
      <div className="ml-auto">
        <span className={clsx('badge', {
          'badge-primary': activity.type === 'inspection',
          'badge-success': activity.type === 'training',
          'badge-danger': activity.type === 'certificate',
          'badge-warning': activity.type === 'system',
        })}>
          {activity.type === 'inspection' && '巡检'}
          {activity.type === 'training' && '培训'}
          {activity.type === 'certificate' && '证件'}
          {activity.type === 'system' && '系统'}
        </span>
      </div>
    </div>
  );
};

export default ActivityFeed;